<template>
  <div>
    <table>
      <thead>
        <tr>
          <th style="min-width: 150px;">{{ $t('Nivel de Severidad') }}</th>
          <th>{{ $t('Descriptor') }}</th>
          <th style="min-width: 150px;">{{ $t('Factor de Severidad') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="impacto in impactos" :key="impacto._id">
          <td>{{impacto.nivelSeveridad}}</td>
          <td @click="click(impacto)">{{ impactType && impacto["descriptor"] }}</td>
          <td>{{impacto.factorSeveridad}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TablaSeveridad',
  props: {
    impactType: {
      required: true,
      default: 'descriptor',
    },
    click: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      impactos: [
        {
          _id: 3,
          nivelSeveridad: 5,
          factorSeveridad: 1000,
          descriptor: this.$t(
            `6 o más fatalidades, o 6 o más enfermedades que acortan la vida; o impacto severo al medioambiente y donde la recuperación 
            de la función del ecosistema tome 10 años o más; o impacto severo en la comunidad que dure más de 12 meses o una violación 
            comprobada de los derechos humanos que afecte a 6 o más personas; o impacto severo en la reputación de la compañía, a la 
            oportunidad de inversión, los derechos legales o cumplimiento, la propuesta de valor social o a la capacidad de acceder a 
            oportunidades a nivel global; o US$2000 millones o más (2)`,
          ),
        },
        {
          _id: 4,
          nivelSeveridad: 4,
          factorSeveridad: 300,
          descriptor: this.$t(
            `1-5 fatalidades o 1-5 enfermedades que acortan la vida; o impacto grave en el medioambiente, donde la recuperación de la 
            función del ecosistema tome entre 3 y 10 años; o impacto grave en la comunidad que dure de 6 a 12 meses o una violación 
            comprobada de los derechos humanos que afecte a entre 1 y 5 personas; o impacto grave en la reputación de la compañía, 
            a la oportunidad de inversión, los derechos legales o el cumplimiento, la propuesta de valor social o la capacidad de acceder 
            a oportunidades a nivel nacional; o Entre US$250 y US$2000 millones (2).`,
          ),
        },
        {
          _id: 5,
          nivelSeveridad: 3,
          descriptor: this.$t(
            `Incapacidad permanente/de largo plazo, o lesión o enfermedad que altere la vida de una o más personas; o impacto sustancial 
            en el medioambiente, donde la recuperación de la funcioón del ecosistema tome entre 1 y 3 años; o impacto grave en la comunidad 
            que dure de 2 a 6 meses; o impacto sustancial en la reputación de la compañía, los derechos legales o el cumplimiento, la propuesta 
            de valor social o la capacidad de acceder a oportunidades a nivel nacional; o entre US$50 y US$250 millones (2).`,
          ),
          factorSeveridad: 100,
        },
        {
          _id: 6,
          nivelSeveridad: 2,
          factorSeveridad: 30,
          descriptor: this.$t(
            `Lesión o enfermedad que no altera la vida, o incapacitan de corto plazo de una o más personas; o impacto medible, pero limitado
             en el medioambiente, donde la recuperación de la función del ecosistema tome menos de 1 año; o impacto medible, pero limitado 
             en la comunidad que dure menos de un mes; o impacto medible, pero limitado en la reputación de la compañía, derechos legales o 
             cumplimiento, o propuesta de valor social a nivel local (región, ciudad, pueblo); o ENtre US$2 y US$50 millones. (2)`,
          ),
        },
        {
          _id: 7,
          nivelSeveridad: 1,
          factorSeveridad: 10,
          descriptor: this.$t(
            `Impactos de bajo nivel que solo requieren primeros auxilios; o Impacto menor y temporal en el medioambiente, donde el ecosistema 
            se recupera con poca intervención; o Impacto menos y temporal en la comunidad que se recupera con poca intervención; Impacto menor 
            y temporal en la reputación de la compañía, derechos legales o cumplimiento, o propuesta de valor social; o Menos de US$2 millones.`,
          ),
        },
      ],
    };
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}
thead {
  color: white;
}
thead tr:first-child {
  background-color: rgb(230, 84, 0);
}
thead tr:nth-child(2) {
  background-color: rgb(250, 182, 54);
}
td,
th {
  padding: 10px;
  border: 1px solid #454545;
}
td:first-child,
td:last-child {
  background-color: rgb(248, 214, 150);
  text-align: center;
  font-weight: bold;
}
td:nth-child(2),
td:nth-child(3) {
  padding: 15px;
}
td:nth-child(2):hover,
td:nth-child(3):hover,
td:nth-child(4):hover {
  cursor: pointer;
  transition: 0.5s background-color;
  background-color: #ececec;
}
</style>
